import DashboardIcon from '@mui/icons-material/Dashboard';

const home = {
  id: 'home',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Home',
      type: 'item',
      url: '/home',
      icon: DashboardIcon,
      breadcrumbs: false
    }
  ]
};

export default home;
